<template>
  <div class="flex flex-col h-full">
    <PageContent class="pt-6">
      <div v-if="hasActionSlot">
        <slot name="action" />
      </div>

      <div v-if="hasTitleSlot" class="mb-3">
        <h1 class="text-2xl font-bold"><slot name="title" /></h1>
      </div>
    </PageContent>

    <slot />

    <div v-if="hasFooterSlot">
      <Divider />
      <PageContent class="py-6">
        <slot name="footer" />
      </PageContent>
    </div>
  </div>
</template>

<script>
  import PageContent from './PageContent';
  import Divider from '@/components/global/base-divider';

  export default {
    name: 'Page',

    components: {
      Divider,
      PageContent,
    },

    computed: {
      hasActionSlot() {
        return !!this.$slots.action;
      },

      hasTitleSlot() {
        return !!this.$slots.title;
      },

      hasFooterSlot() {
        return !!this.$slots.footer;
      },
    },
  };
</script>
